module.exports = __webpack_public_path__ + "static/media/konami-logo.5e068df6.svg";